// extracted by mini-css-extract-plugin
export default {"NavBar":"PFSNavBar_NavBar__7N-Nr"};